import { render, staticRenderFns } from "./dialogCreditorHistory.vue?vue&type=template&id=0bc15e61"
import script from "./dialogCreditorHistory.vue?vue&type=script&lang=js"
export * from "./dialogCreditorHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports